import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-invalid-token',
    templateUrl: './invalid-token.component.html',
    standalone: false
})

export class InvalidTokenComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void { }

}
